// The stop a company meets while a new payout contract waits for its signature,
// as Apple stops a developer until an updated agreement is accepted: no new
// products and nothing sent for review until it has read and signed it. The
// button opens the contract (Company → Contract).
import React from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { DocumentTextIcon } from "@heroicons/react/24/outline"
import usePortalTexts from "./texts/usePortalTexts"
import { PORTAL } from "./texts/bundles"

/** Where the company's contract is, in the portal (the site's language prefix kept). */
export const contractUrl = (orgId) => {
  const prefix = typeof window !== "undefined" && /^\/[a-z]{2}(\/|$)/.test(window.location.pathname) ? window.location.pathname.slice(0, 3) : ""
  return `${prefix}/vendor?org=${encodeURIComponent(orgId)}&section=company&company=contract`
}

export default function ContractRequiredDialog({ open, orgId, onClose, onOpenContract }) {
  const t = usePortalTexts(PORTAL)
  const openContract = () => {
    onClose?.()
    if (onOpenContract) return onOpenContract()
    window.location.assign(contractUrl(orgId))
  }
  return (
    <Modal 
      isOpen={!!open} 
      onClose={onClose} 
      variant="admin" 
      closeOnEscape title={t`Review your new contract`} 
      styleOverrides={{ container: "w-[min(92vw,520px)] bg-admin_paper rounded-lg border border-admin_bordered shadow-lg" }}
    >
      <div className="flex flex-col gap-4 p-5 pt-1" data-testid="contract-required">
        <div className="flex items-start gap-3">
          <DocumentTextIcon className="w-8 h-8 shrink-0 text-amber-500" />
          <Typography variant="admin_txt1">
            {t`Aldoo has sent you a new payout contract. Until you review and sign it, you cannot add new products or send products for review.`}
          </Typography>
        </div>
        <div className="flex justify-end gap-2">
          <Button 
            variant="admin_secondary" 
            onClick={onClose}
          >
            {t`Cancel`}
          </Button>
          <Button 
            variant="admin_primary" 
            onClick={openContract} 
            data-testid="contract-required-open"
          >
            {t`Review the contract`}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
